import { execAdmin } from '../utils';

interface GetDownloadUrlVariables {
  id: number;
  downloadTarget: string;
}

interface GetDownloadUrlResponse {
  catalogUpload: {
    downloadUrl: string | null;
  };
}

const CATALOG_UPLOAD_DOWNLOAD_URL_QUERY = `
  query catalogUploadDownloadUrl($id: Int!, $downloadTarget: String) {
    catalogUpload(id: $id) {
      downloadUrl(downloadTarget: $downloadTarget)
    }
  }
`;

export const getCatalogUploadDownloadUrl = async (
  id: number,
  downloadTarget: 'location' | 'errorContents' | 'successContents' | 'inputContents' | 'logContents',
): Promise<string | null> => {
  const data = await execAdmin<GetDownloadUrlVariables, GetDownloadUrlResponse>(
    CATALOG_UPLOAD_DOWNLOAD_URL_QUERY,
    { variables: { id, downloadTarget } },
  );
  return data.catalogUpload?.downloadUrl ?? null;
};
